import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { AbilityContext } from "../../utility/context/Can";
import { Layout, Circle, Sidebar, UserCheck, Home } from "react-feather";
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";

export default function verticalEvent() {
  const eventId = useSelector((state) => state.globalConst.eventId);
  const ability = useContext(AbilityContext);

  const array = [
    {
      id: "beginning",
      title: "Inicio",
      icon: <Home size={20} />,
      navLink: `/event/${eventId}/home`,
    },
    // ability.can("Read", "Information") || ability.can("Manage", "All") ?
    {
      id: "landing",
      title: "Landing page",
      icon: <Layout size={20} />,
      children: [
        // (ability.can('Read', 'Information') || ability.can('Manage', 'All') ?
        {
          id: "information",
          title: "Información",
          icon: <Circle />,
          navLink: `/event/${eventId}/landing/information`,
          action: "read",
          resource: "landing",
          disabled: true,
        },
        // : { disabled: true }),
        // ability.can("Read", "Information") || ability.can("Manage", "All")
        // ?
        {
          id: "speakers",
          title: "Speakers",
          icon: <Circle />,
          navLink: `/event/${eventId}/landing/speakers`,
          action: "read",
          resource: "landing",
        },
        // : { disabled: true },
        // ability.can("Read", "Information") || ability.can("Manage", "All")
        //   ?
        {
          id: "conference",
          title: "Conferencias",
          icon: <Circle />,
          navLink: `/event/${eventId}/landing/conferences`,
          action: "read",
          resource: "landing",
        },
        // : { disabled: true },
        // ability.can("Read", "Information") || ability.can("Manage", "All")
        //   ?
        {
          id: "sponsors",
          title: "Aliados Estratégicos",
          icon: <Circle />,
          navLink: `/event/${eventId}/landing/sponsors`,
          action: "read",
          resource: "landing",
        },
        // : { disabled: true },
        // ability.can("Read", "Information") || ability.can("Manage", "All")
        //   ?
        {
          id: "exhibitors",
          title: "Expositores",
          icon: <Circle />,
          navLink: `/event/${eventId}/landing/exhibitors`,
          action: "read",
          resource: "landing",
        },
        // : { disabled: true },
      ],
    },
    // : { disabled: true },
    ability.can("Read", "Tickets") ||
    ability.can("Read", "Orders") ||
    ability.can("Read", "Coupons") ||
    ability.can("Read", "Subscriptions") ||
    ability.can("Manage", "All")
      ? {
          id: "admin",
          title: "Administración",
          icon: <Sidebar size={20} />,
          children: [
            ability.can("Read", "Tickets") || ability.can("Manage", "All")
              ? {
                  id: "tickets",
                  title: "Boletos",
                  icon: <Circle />,
                  navLink: `/event/${eventId}/admin/tickets`,
                  action: "read",
                  resource: "landing",
                }
              : { disabled: true },
            ability.can("Read", "Orders") || ability.can("Manage", "All")
              ? {
                  id: "orders",
                  title: "Ordenes",
                  icon: <Circle />,
                  navLink: `/event/${eventId}/admin/orders`,
                  action: "read",
                  resource: "landing",
                }
              : { disabled: true },
            ability.can("Read", "Reservations") || ability.can("Manage", "All")
              ? {
                  id: "reservations",
                  title: "Reservaciones",
                  icon: <Circle />,
                  navLink: `/event/${eventId}/admin/reservations`,
                  action: "read",
                  resource: "landing",
                }
              : { disabled: true },
            {
              id: "invitations",
              title: "Invitaciones",
              icon: <Circle />,
              navLink: `/event/${eventId}/admin/invitations`,
              action: "read",
              resource: "landing",
            },
            true
              ? {
                  id: "coupons",
                  title: "Cupones",
                  icon: <Circle />,
                  navLink: `/event/${eventId}/admin/coupons`,
                  action: "read",
                  resource: "landing",
                }
              : { disabled: true },
            ability.can("Read", "Subscriptions") || ability.can("Manage", "All")
              ? {
                  id: "subscription",
                  title: "Suscripciones",
                  icon: <Circle />,
                  navLink: `/event/${eventId}/admin/subscription`,
                  action: "read",
                  resource: "landing",
                }
              : { disabled: true },
            ability.can("Read", "Tickets") || ability.can("Manage", "All")
              ? {
                  id: "Notifications",
                  title: "Notificaciones",
                  icon: <Circle />,
                  navLink: `/event/${eventId}/notifications`,
                  action: "read",
                  resource: "landing",
                }
              : { disabled: true },
            {
              id: "addons",
              title: "Complementos",
              icon: <Circle />,
              navLink: `/${eventId}/addons/list`,
              action: "read",
              resource: "landing",
            },
            // (ability.can('Read', 'Deposits') || ability.can('Manage', 'All') ? {
            //   id: "deposits",
            //   title: "Depósitos",
            //   icon: <Circle />,
            //   navLink: `/event/${eventId}/admin/deposits`,
            //   action: "read",
            //   resource: "landing",
            // }
            // : { disabled: true }),
            // ability.can("Read", "Deposits") || ability.can("Manage", "All")
            //   ? {
            //       id: "statistics",
            //       title: "Estadisticas",
            //       icon: <Circle />,
            //       navLink: `/event/${eventId}/admin/statistics`,
            //       action: "read",
            //       resource: "landing",
            //     }
            //   : { disabled: true },
          ],
        }
      : { disabled: true },
    ability.can("Read", "Tickets") ||
    ability.can("Read", "Orders") ||
    ability.can("Read", "Coupons") ||
    ability.can("Read", "Subscriptions") ||
    ability.can("Manage", "All")
      ? {
          id: "assistants",
          title: "Asistentes",
          icon: <UserCheck />,
          children: [
            {
              id: "list",
              title: "Listado",
              icon: <Circle />,
              navLink: `/event/${eventId}/assistants`,
              action: "read",
              resource: "landing",
            },
          ],
        }
      : { disabled: true },
    // ability.can("Read", "Tickets") ||
    // ability.can("Read", "Orders") ||
    // ability.can("Read", "Coupons") ||
    // ability.can("Read", "Subscriptions") ||
    // ability.can("Manage", "All")
    //   ? {
    //       id: "add-on",
    //       title: "Complementos",
    //       icon: <ExtensionOutlinedIcon />,
    //       children: [
    //         {
    //           id: "list",
    //           title: "Listado",
    //           icon: <Circle />,
    //           navLink: `/${eventId}/addons/list`,
    //           action: "read",
    //           resource: "landing",
    //         },
    //       ],
    //     }
    //   : { disabled: true },
  ];

  return array;
}
